import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getHexTextColorHex } from 'library/colors';
import { Icon, Tooltip } from 'antd';
import Notes from './Notes';

const Event = ({ event }) => {
  const startDate = event.start_time;
  const endDate = event.end_time;
  const singleDayEvent = !event.multiDay;
  const className = classNames(
    'bhp-time'
  );
  const toolTipText = singleDayEvent ? 'Single Day Activity' : 'Multi Day Activity';

  return (
    <div
      className="bhp-event-content"
      style={{
        backgroundColor: event.color,
        color: getHexTextColorHex(event.color)
      }}
    >
      <Tooltip title={toolTipText}>
        <div className={className}>
          {singleDayEvent ? `${startDate.format('HH:mm')} - ${endDate.format('HH:mm')} ` : `${startDate.format('Do HH:mm')} - ${endDate.format('Do HH:mm')} `}
          {!singleDayEvent && <Icon type="column-width" className="multiple-days__icon" />}
        </div>
      </Tooltip>
      {event.notes && <Notes notes={event.notes} />}
      <div className="bhp-title">
        {event.title}
      </div>
    </div>
  );
};

Event.propTypes = {
  event: PropTypes.object.isRequired
};

export default Event;
